<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary">
        <div class="h4 text-center">
          <linkto :link="'/'"/>
          <span class="text-center">
            Kezelők lista
          </span>
        </div>
      </div>
    </div>
    <div class="m-2 text-center">
    	<div class="row d-flex justify-content-center">
    		<div class="col-12 col-sm-12 col-md-6 col-lg-4">
    			<div class="mui-textfield mui-textfield">
			        <input type="text" v-model="search">
			        <label>Név / Város / Régió keresés</label>
			    </div>
          <router-link :to="'/managers/new_manager'" class="btn btn-lg btn-outline-primary">
                Új kezelő
          </router-link>
			    <button class="btn btn-lg btn-outline-primary" @click.prevent="load">Keresés</button>
    		</div>
    	</div> 
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Név</th>
            <th scope="col">Város</th>
            <th scope="col">Régió</th>
            <th scope="col">Régió -ig</th>
            <th scope="col">Akítv</th>
            <th scope="col">Módosít</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in managers" :key="index">
            <td>{{item.azon}}</td>            
            <td>{{item.nev}}</td>
            <td>{{item.varos}}</td>
            <td>{{item.regio}}</td>
            <td>{{item.regio_max}}</td>
            <td>
                <span class="text-success" v-if="item.aktiv==1">
                    <i class="fas fa-check"></i>
                </span>
                <span class="text-danger" v-else>
                    <i class="fas fa-times"></i>
                </span>
            </td>
            <td>
              <router-link
                :to="`/manager/${item.azon}`"
              >
                Módosít
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'managers',
  components: {
  },
  data () {
    return {
      search: ``,
      managers: []
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    load(){
      this.$Progress.start()
      this.req.post(`/managers/search`,{
        search: this.search
      })
        .then(res => {
        	this.managers = res.data.managers
          	this.$Progress.finish()
        })
        .catch(err => {
          console.log(err)
          this.$Progress.fail()
        })
    }
  },
  computed: {
  	
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/managers/managers.vue